<template>
    <div>
        <list-page getter="global"
                   sort-by-prop="make"
                   view-type-prop="list"
                   :sort-by-desc-prop="false"
                   :table-fields="fields"
                   :enable-selection="true"
                   @selectVehicle="onSelect"
                   :table-tr-class="trClass"
                   :disableHead="disableHead"
                   :hidePrices="hidePrices"
                   :showRepFilter="true"
                   :filterBySharedSalesReps="false"
                   :hideAddNew="true">
            <template v-slot:title="">
                SBL Global Stock
            </template>
            <template v-slot:right_buttons="">
                <a class="btn" @click.prevent="openSendEmailModalFunc()">Send Email</a>
            </template>
        </list-page>
        <vehicle-stock-send-email :vehicle-ids="selected" v-model="openSendEmailModal"/>
    </div>
</template>
<script>
    import ListPage from './ListPage'
    import {numberWithCommas, getDate} from '../../util/common'
    import VehicleStockSendEmail from "./VehicleStockSendEmail";
    import {dateFormat} from "vue-filter-date-format";
    export default {
        props: [
            'disableHead',
            'hidePrices'
        ],
        components: {
            'list-page': ListPage,
            VehicleStockSendEmail
        },
        data(){
            return {
                selected: [],
                openSendEmailModal: false,
                fields: [
                    {label: 'Vehicle Code', key: 'stock_id',sortable: true},
                    {label: 'Purchased', key: 'sold_date',sortable: true, formatter: v => getDate(v)},
                    {label: 'Sales Rep', key: 'global_list_rep_id',sortable: true, formatter: this.getRep},
                    {label: 'Retail Price', key: 'global_list_retail',sortable: false},
                    {label: 'Make', key: 'make',sortable: true},
                    {label: 'Model', key: 'model', sortable: true},
                    {label: 'Chassis', key: 'chassis', sortable: true},
                    {label: 'Year', key: 'year',sortable: true},
                    {label: 'KMs', key: 'mileage', sortable: true},
                    {label: 'CCs', key: 'engine_capacity', sortable: true},
                    {label: 'SBL Cost', key: 'global_list_display_price',sortable: false},
                    {label: 'Days', key: 'global_list_date', sortable: true, formatter: this.dateCounter},
                    {label: 'Notes', key: 'global_list_note', sortable: true, formatter: this.noteFormatter},
                    {label: 'Actions', key: 'actions'},
                ],
            }
        },
        methods: {
            getRep(value, key, item){
                if (item.global_rep && item.global_rep.bid_initials) {
                    return item.global_rep && item.global_rep.bid_initials;
                }
                return 'N/A'
            },
            trClass(item, type){
                if (type === 'row' && item && item.global_on_behalf && item.global_on_behalf.profile && item.global_on_behalf.profile.global_list_colour) {
                    return 'row-colour-'+item.global_on_behalf.profile.global_list_colour;
                }
                return '';
            },
            dateCounter(value, key, item){
                const now = window.moment()
                if (item.global_list_date) {
                    const days = window.moment(now).diff(item.global_list_date, 'days')
                    return days;
                }
                return '';
            },
            noteFormatter(value, key, item){
                if (value) {
                    // if (value.length > 80) {
                    //     return value.substring(0, 80) + '...';
                    // }
                    return value;
                }
                return '';
            },
            onSelect(vehicle, all_selected){
                this.selected = all_selected
            },
            openSendEmailModalFunc(){
                if (this.selected.length) {
                    this.openSendEmailModal = true
                } else {
                    this.$message.error('Please select at least 1 vehicle to send an email.');
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/GlobalStock.vue